import { InformationTooltip } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface StatCardProps {
  label: string;
  value: string | number;
  color?: string;
  tooltip?: string;
}

/**
 * Individual stat card component for displaying metric information
 */
export const StatCard = ({
  label,
  value,
  color = "text-gray-700",
  tooltip,
}: StatCardProps) => {
  return (
    <div className="flex flex-col justify-between w-24 h-14 border border-gray-200 rounded-[10px] py-1 px-2 shrink-0">
      <p className="text-[10px] text-gray-600 leading-tight">{label}</p>
      <div className="flex flex-col gap-0.5">
        <div className="flex flex-row gap-1 items-center justify-between">
          <p className={cn("text-sm font-semibold", color)}>{value}</p>
          {tooltip && (
            <InformationTooltip
              content={tooltip}
              className="w-3 h-3 p-0 bg-transparent hover:bg-transparent active:bg-transparent focus:bg-transparent outline-hidden focus-visible:outline-hidden"
              offset={8}
              crossOffset={56}
              placement="right"
              align="left"
              tooltipVariant="default"
              tooltipClassName="px-2 py-1.5 max-w-[300px] text-xs font-normal leading-4 tracking-[0.01em]"
              isClickable={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};
